import React from "react";
import { PostInfo } from "../post/Post";
import { useMediaProcessing } from "../../shared/hooks/useMediaProcessing";
import "./UploadingPost.scss";

interface UploadingPostProps {
	postInfo: PostInfo;
	onReady: (postId: string, updatedPost: PostInfo) => void;
}

const UploadingPost: React.FC<UploadingPostProps> = ({ postInfo, onReady }) => {
	// Use media processing hook to poll and get progress
	const { currentPost, progress } = useMediaProcessing(postInfo, (updatedPost) => {
		// When status becomes ready, notify parent
		if (updatedPost.mediaStatus === "ready") {
			onReady(updatedPost.id, updatedPost);
		}
	});

	const mediaType = postInfo.type === "video" ? "video" : "image";

	return (
		<div className="uploading-post">
			<div className="upload-icon">
				{mediaType === "video" ? "🎬" : "📷"}
			</div>
			<div className="progress-info">
				<div className="progress-text">
					Uploading {mediaType}... {progress}%
				</div>
				<div className="progress-bar">
					<div
						className="progress-fill"
						style={{ width: `${progress}%` }}
					/>
				</div>
			</div>
		</div>
	);
};

export default UploadingPost;
